type PrivatePolicyFlagButton = {
  code: string;
  label: string;
  onClick: () => void;
};

interface QueryUrlParams {
  hideHeader?: boolean;
}

enum FlagCode {
  AU = "au",
  CN = "cn",
}

export { FlagCode };

export type { PrivatePolicyFlagButton, QueryUrlParams };
